module.exports = __webpack_public_path__ + "static/Raleway-VariableFont_wght-5168d1914d838a5777f6f7b9abffecc4.woff2";